import { Venue } from '@app/domain/Venue'
import { Area } from '../../../../../domain/Area'
import { Booking } from '../../../../../domain/Booking'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { Observable } from 'rxjs'

@Component({
    selector: 'app-paged-booking-list',
    templateUrl: './paged-booking-list.component.html',
    styles: [`
        :host
            display: flex
            flex: 1 1 auto
            flex-direction: column
            min-height: 0
            position: relative
    `],
})
export class PagedBookingListComponent {

    @Input() venue!: Venue
    @Input() bookings$?: Observable<{ booking: Booking; area?: Area }[]>
    @Input() isSearching!: boolean
    @Input() isShowingResults!: boolean
    @Input() emptyStateTitle = 'No bookings found'
    @Input() emptyStateDescription?: string
    @Input() config!: {
        itemsPerPage: number,
        currentPage: number,
        totalItems: number,
    }
    @Output() bookingSelected = new EventEmitter<Booking>()
    @Output() pageChanged = new EventEmitter<number>()
}
